<template>
  <div>

    <div class="left-menu-trigger out" @click="bar">
      <div v-bind:class="{ animate: isOpen }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="left-menu" v-bind:class="{ open: isOpen }">
      <div class="menu-drawer-backdrop" @click="close"></div>
      <div class="menu-drawer-bg"></div>
        <nav>
          <ul class="main-menu">
            <li v-for="pg in pages" v-bind:key="pg.id">
              <a @click="menu(pg.id)">{{pg.nom}}</a>
            </li>
            <br/><br/>
            <li v-for="pg in pages2" v-bind:key="pg.id">
              <a @click="menu(pg.id)">{{pg.nom}}</a>
            </li>
          </ul>
        </nav>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    pages: Array,
    pages2: Array
  },

  data: () => ({
    isOpen: false
  }),

  mounted () {
  },

  computed: {
  },

  methods: {
    bar() {
      this.isOpen = !this.isOpen
    },

    close() {
      this.isOpen = false
    },

    menu(p) {
      this.isOpen = false
      this.$emit('clicked', p)
    }
  }

}

</script>

<style scoped>

.menu-drawer-backdrop, .left-menu.open nav {
  opacity: 1;
  visibility: visible;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.menu-drawer-backdrop {
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  transition: all 600ms ease 100ms;
}

.left-menu.open .menu-drawer-bg, .left-menu.open .menu-drawer-backdrop, .left-menu.open nav {
  opacity: 1;
  visibility: visible;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.menu-drawer-bg, .menu-drawer-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  z-index: 9;
}

.menu-drawer-bg {
  min-width: 320px;
  max-width: 400px;
  width: 33vw;
  background: #fff;
  -webkit-transform: translate3d(-50px, 0, 0);
  transform: translate3d(-50px, 0, 0);
  transition: all 300ms ease;
}

.menu-drawer-backdrop {
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  transition: all 600ms ease 100ms;
}

.left-menu-trigger {
  position: absolute;
  top: 20px;
  left: 20px;
  -webkit-transform: scale(1);
  transform: scale(1);
  width: 60px;
  height: 60px;
  z-index: 11;
  cursor: pointer;
}

.left-menu-trigger div.animate {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.left-menu-trigger div {
  width: 30px;
  height: 30px;
  top: 15px;
  left: 15px;
  position: relative;
  transition: -webkit-transform 200ms ease;
  transition: transform 200ms ease;
  transition: transform 200ms ease, -webkit-transform 200ms ease;
}

.left-menu-trigger span {
  position: absolute;
  width: 100%;
  height: 2px;
  top: 50%;
  left: 0;
  background: #000;
  transition: all 200ms ease;
}

.left-menu-trigger div.animate {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.left-menu-trigger div {
  width: 30px;
  height: 30px;
  top: 15px;
  left: 15px;
  position: relative;
  transition: -webkit-transform 200ms ease;
  transition: transform 200ms ease;
  transition: transform 200ms ease, -webkit-transform 200ms ease;
}

.left-menu-trigger span:nth-child(1) {
  -webkit-transform: translateY(-8px);
  transform: translateY(-8px);
}

.left-menu-trigger span:nth-child(2) {
  -webkit-transform: translateY(0);
  transform: translateY(0);
}

.left-menu-trigger span:nth-child(3) {
  -webkit-transform: translateY(8px);
  transform: translateY(8px);
}

.left-menu-trigger div.animate span:nth-child(1) {
  -webkit-transform: rotate(-45deg) translateY(0);
  transform: rotate(-45deg) translateY(0);
}

.left-menu-trigger div.animate span:nth-child(2) {
  opacity: 0;
}

.left-menu-trigger div.animate span:nth-child(3) {
  -webkit-transform: rotate(45deg) translateY(0);
  transform: rotate(45deg) translateY(0);
}

ul {
  margin-bottom: 50px;
}

nav {
  position: absolute;
  top: 100px;
  left: 80px;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: all 300ms ease;
  -webkit-transform: translate3d(-20px, 0, 0);
  transform: translate3d(-20px, 0, 0);
}

nav ul {
  list-style: none;
  margin: 0;
  margin-bottom: 0px;
  padding: 0;
}

ul a {
  font-size: 0.9rem;
  padding: 12px 0;
}

nav a {
  display: block;
  text-transform: uppercase;
  text-decoration: none;
  outline: none !important;
  color: #707070;
}

nav a:hover {
  color: #000;
}

a {
  transition: color 200ms ease, opacity 200ms ease;
  outline: none !important;
  background: 0 0;
  cursor: pointer;
}

@media screen and (max-width: 750px)
{
  .left-menu-trigger {
    top: 17px;
    left: 6px;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }
}

</style>
